import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const grid = document.getElementById('posts-grid');
  const loadMore = document.getElementById('posts-load-more');
  const filterButtons = document.querySelectorAll('.posts-listing__category');

  if (!grid) return;

  const API_URL = grid.dataset.api;
  const PER_PAGE = parseInt(grid.dataset.perPage) || 12;

  let state = {
    paged: 1,
    contentType: '',
    loading: false,
    totalPages: parseInt(grid.dataset.totalPages) || 1,
  };

  function setLoadingState(isLoading, showLoader = false) {
    state.loading = isLoading;
    grid.classList.toggle('is-loading', isLoading && showLoader);
    if (loadMore) loadMore.disabled = isLoading;
    filterButtons.forEach((btn) => (btn.disabled = isLoading));
  }

  async function fetchPosts({ append = false, showLoader = false } = {}) {
    if (state.loading) return;
    setLoadingState(true, showLoader);

    const params = new URLSearchParams({
      per_page: PER_PAGE,
      paged: state.paged,
    });

    if (state.contentType) params.set('content_type', state.contentType);

    try {
      const res = await fetch(`${API_URL}?${params}`);
      if (!res.ok) throw new Error(res.statusText);

      const data = await res.json();

      if (!append) grid.innerHTML = '';
      if (data.html) grid.insertAdjacentHTML('beforeend', data.html);

      state.totalPages = parseInt(data.total_pages) || 1;

      if (loadMore) {
        const hasMore = state.paged < state.totalPages;
        loadMore.style.display = hasMore ? 'inline-block' : 'none';
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingState(false);
    }
  }

  loadMore?.addEventListener('click', () => {
    state.paged++;
    fetchPosts({ append: true });
  });

  filterButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const isAlreadyActive = btn.classList.contains('is-active');

      filterButtons.forEach((b) => {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });

      if (isAlreadyActive) {
        state.contentType = '';
      } else {
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        state.contentType = btn.dataset.contentType || '';
      }

      state.paged = 1;
      const header = document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 0;
      const extraOffset =
        parseFloat(getComputedStyle(document.documentElement).fontSize) * 2;

      const yOffset = -(headerHeight + extraOffset + 25);
      const y = grid.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });
      fetchPosts({ append: false, showLoader: true });
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const preselected = urlParams.get('type');

  if (preselected) {
    const targetBtn = document.querySelector(
      `.posts-listing__category[data-content-type="${preselected}"]`
    );
    if (targetBtn) {
      targetBtn.classList.add('is-active');
      targetBtn.setAttribute('aria-selected', 'true');
      state.contentType = preselected;
      fetchPosts({ append: false, showLoader: true });

      document
        .querySelector('.posts-listing')
        ?.scrollIntoView({ behavior: 'smooth' });
    }
  }
});
